import React from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import googleConfig from './config/googleConfig';

const CLIENT_ID = googleConfig.client_id;

if (!CLIENT_ID) {
  console.error('Missing required parameter CLIENT_ID');
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <GoogleOAuthProvider clientId={CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);